import slick from 'jquery_version/slick.js';
// import imgLiquid from 'plugs/imgLiquid-min.js';
// import fullpage from 'fullpage.js'
// import 'svg.js';
// import 'jquery.easing.1.3.js';;
// import 'jquery.mCustomScrollbar.concat.min.js';
// import 'fullpage.extensions.min.js';
// import 'scrolloverflow.min.js';
// import 'jquery_version/jquery.validate.min.js';


$(document).ready(function () {
  $('body').addClass('loading');

  $("html,body").animate({
    scrollTop: $(this).scrollTop() - 1
  }, 10);

  /* ==========================================================================
                * ALL
    ==========================================================================*/
  var $window = $(window);
  var windowHeight = $(window).height();
  var windowWidth = $(window).width();
  var footerHeight = $('footer').height();
  /* ==========================================================================
                 * 鼠標
     ==========================================================================*/
  // $(document).mousemove(function(e){
  //   $('.curcil').css(
  //     {
  //       left: e.pageX,
  //       top: e.pageY - scrollTop
  //     }
  //   )
  // })
  // $('a,input,select,textarea,label').mouseenter(function(e){
  //   $('.curcil').css(
  //     {
  //       opacity: 0
  //     }
  //   )
  // })
  // $('a,input,select,textarea,label').mouseleave(function(e){
  //   $('.curcil').css(
  //     {
  //       opacity: 1
  //     }
  //   )
  // })


  /* ==========================================================================
                * slick
    ==========================================================================*/
  $('.ind-banner ul').slick({
    dots: true,
    infinite: true,
    fade: true,
    speed: 500,
    cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnFocus: false,
    pauseOnHover: false,
  });

  $('.indexPage .item1 .mo ul').slick({
    dots: false,
    infinite: true,
    fade: true,
    speed: 500,
    cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll: 1,
    // autoplay: true,
    // autoplaySpeed: 2000,
  });

  $('.indexPage .item5 ul').slick({
    dots: false,
    infinite: true,
    speed: 500,
    cssEase: 'linear',
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          cssEase: 'linear',
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });

  $('.indexPage .item6 ul').slick({
    dots: false,
    infinite: true,
    speed: 500,
    cssEase: 'linear',
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          cssEase: 'linear',
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });

  $('.aboutPage .item4 ul').slick({
    dots: false,
    infinite: true,
    speed: 500,
    cssEase: 'linear',
    slidesToShow: 4,
    slidesToScroll: 1,
    appendArrows: $('.aboutPage .item4 .btn-bx'),
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          cssEase: 'linear',
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 768,
        settings: {
          cssEase: 'linear',
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });
  $('.aboutPage .item6 ul').slick({
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    cssEase: 'linear',
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          cssEase: 'linear',
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      }
    ]
  });
  /* ==========================================================================
                    * resize
        ==========================================================================*/
  var windowHeight = $(window).height();
  var miniHeight = windowHeight - $('footer').outerHeight();
  $('main').css({
    "min-height": miniHeight + "px"
  });

  $(window).on('resize', function (event) {
    var windowHeight = $(window).height();
    var miniHeight = windowHeight - $('footer').outerHeight();

    $('main').css({
      "min-height": miniHeight + "px"
    });

    if ($(this).width() > 980) {
      $('body,html,footer').removeAttr("style");
      $('.header_box').removeClass('open').removeAttr('style');
      $('.nav_box').removeAttr("style");
      $('.hamburger-menu').removeClass('animate').removeAttr("style");
    }

  });


  /* ==========================================================================
            * header-menu
==========================================================================*/
  $('.menu-wrapper').on('click', function () {
    if (!$('.hamburger-menu').hasClass('animate')) {
      $('.hamburger-menu').addClass('animate');
      $('.hamburger-menu').removeClass('colsanimate');
      $('.nav_box').addClass('navop').stop().fadeIn();
      $('.navopbg').addClass('navbgop');
      $('.header_box').addClass('open');
      $('body,html').css({ 'overflow': 'hidden' }).addClass('ops');
      $('footer').css({ 'z-index': '-1' });

    } else {
      $('.hamburger-menu').addClass('colsanimate');
      $('.hamburger-menu').removeClass('animate');
      $('footer').removeAttr("style");
      $('.nav_box').removeClass('navop').stop().fadeOut();
      $('.navopbg').removeClass('navbgop');
      $('.header_box').removeClass('open');
      $('body,html,.sub_menu').removeAttr("style").removeClass('ops');
      $('.product_bottom').removeClass('active').removeAttr('style');
    }
  });



  /* ==========================================================================
                * popup
    ==========================================================================*/
  // $('.h-wlogo').click(function() {
  //   $('.pop-act').addClass('show-pop');
  //   $('body,html').css({ 'overflow': 'hidden' });
  // })

  // $('.clos-btn').click(function() {
  //   $('.pop-act').removeClass('show-pop');
  //   $('body,html,.sub_menu').removeAttr("style");
  // })
  // $('.pop-act').click(function() {
  //   var x = event.target;
  //   $(x).addClass('popherecols');
  //   $(x).removeClass('show-pop');
  //   $(x).removeClass('popherecols');
  //   $('body,html,.sub_menu').removeAttr("style");
  // })


  /* ==========================================================================
                * scrollStyle
    ==========================================================================*/
  // $('testscroll').mCustomScrollbar();


  $(window).on('scroll', function () {
    var scrollTop = $(this).scrollTop();
    var top = $('.top_btn');
    var screenHeight = $(window).height();
    var scrollTop2 = $(this).scrollTop() + (screenHeight / 2);
    if (scrollTop > 99) {
      $('.header_show').addClass('chheader');
    } else {
      $('.header_show').removeClass('chheader');
    }
    if (scrollTop > 170) {
      top.addClass('show-topbtn');
    } else {
      top.removeClass('show-topbtn');
    }

    var top_number;
    if ($(this).width() >= 768) {
      top_number = 450;
    } else {
      top_number = 300;
    }
    if (scrollTop2 >= $('footer').offset().top - top_number) {
      top.addClass('fix');
    } else if (scrollTop2 <= $('footer').offset().top + 400) {
      top.removeClass('fix');
    }
  })
  /* ==========================================================================
                * 內頁active 請分散到各頁下面script
    ==========================================================================*/

  // $('.nav_box ul li:nth-child(1) a').addClass('active');
  // $('.nav_box ul li:nth-child(2) a').addClass('active');
  // $('.nav_box ul li:nth-child(3) a').addClass('active');
  // $('.nav_box ul li:nth-child(4) a').addClass('active');
  // $('.nav_box ul li:nth-child(5) a').addClass('active');
  /* ==========================================================================
                * top-btn
    ==========================================================================*/


  $(".top_btn").click(function () {
    $("html,body").animate({ scrollTop: 0 }, 1000, '');
    return false;
  });

  $(window).on('scroll', function gotopfun() {
    var top = $('#topBtn');
    var scrollTop = $(this).scrollTop()
    if (scrollTop >= 60) {
      top.addClass('open');

    } else {
      top.removeClass('open');
    }
    if ($(window).scrollTop() >= $(document).height() - $(window).height() - $('footer').outerHeight(true) + 60) {
      top.addClass('change');
    } else {
      top.removeClass('change');
    }
  })


})

